// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".total-amount-error-message[data-v-ee37d688] {\n  white-space: pre-wrap;\n  text-align: right;\n}", ""]);
// Exports
module.exports = exports;
